// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-wheel-colaboradores {
  margin: 80px auto;
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
}
.container-wheel-colaboradores .ring-one {
  border: 4px solid rgba(123, 107, 228, 0.4);
  position: relative;
  border-radius: 50rem;
  width: 410px;
  height: 410px;
}
.container-wheel-colaboradores .ring-two {
  border: 4px solid rgba(63, 196, 255, 0.4);
  border-radius: 50rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-wheel-colaboradores .ring-two .wheelEmployeeImgHover-editProfile {
  transition: all 0.8s ease-in-out;
  opacity: 0;
  position: absolute;
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin-top: 75px;
  margin-left: -160px;
}
.container-wheel-colaboradores .ring-two .wheelEmployeeImgHover-editProfile svg {
  display: block;
  margin: auto;
}
.container-wheel-colaboradores .ring-two img {
  width: 100%;
  border-radius: 50%;
  transition: all 0.8s ease-in-out;
}
.container-wheel-colaboradores .ring-two .wheelEmployeeLink-editProfile:hover img {
  transform: scale(1.2);
}
.container-wheel-colaboradores .ring-two .wheelEmployeeLink-editProfile:hover .wheelEmployeeImgHover-editProfile {
  opacity: 0.8;
}
.container-wheel-colaboradores .icons-colaboradores {
  border-radius: 50%;
  box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  width: 65px;
  height: 65px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.container-wheel-colaboradores .icons-colaboradores svg {
  width: 45px;
  height: 45px;
  fill: white;
  stroke-width: 25px;
}
.container-wheel-colaboradores .icons-colaboradores:hover {
  transform: scale(1.1);
}
.container-wheel-colaboradores .icons-colaboradores .box-info {
  width: 220px;
  height: 82px;
  position: absolute;
  display: flex;
  flex-direction: column;
}
.container-wheel-colaboradores .icons-colaboradores .box-info .title-colaboradores {
  font-size: 20px;
}
.container-wheel-colaboradores .icons-colaboradores .box-info .detail-colaboradores {
  width: 83px;
  color: #4e5857;
  font-size: 12px;
  font-weight: bold;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(1) {
  top: -20px;
  left: 238px;
  background: #7b6be4;
  color: #7b6be4;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(1) .box-info {
  top: -31px;
  left: 100px;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(2) {
  top: 55px;
  left: 341px;
  background: #6a84ec;
  color: #6a84ec;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(2) .box-info {
  top: 0;
  left: 100px;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(3) {
  top: 175px;
  left: 380px;
  background: #599df3;
  color: #599df3;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(3) .box-info {
  top: 0;
  left: 100px;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(4) {
  top: 295px;
  left: 341px;
  background: #4ab4fa;
  color: #4ab4fa;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(4) .box-info {
  top: 0;
  left: 100px;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(5) {
  top: 370px;
  left: 238px;
  background: #3fc4ff;
  color: #3fc4ff;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(5) .box-info {
  top: 31px;
  left: 100px;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(6) {
  top: 370px;
  left: 112px;
  background: #3bcaf5;
  color: #3bcaf5;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(6) .box-info {
  top: 31px;
  right: 100px;
  align-items: end;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(7) {
  top: 295px;
  left: 9px;
  background: #36d1ea;
  color: #36d1ea;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(7) .box-info {
  top: 0;
  right: 100px;
  align-items: end;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(8) {
  top: 175px;
  left: -30px;
  background: #31d7e0;
  color: #31d7e0;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(8) .box-info {
  top: 0;
  right: 100px;
  align-items: end;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(9) {
  top: 55px;
  left: 9px;
  background: #2cded3;
  color: #2cded3;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(9) .box-info {
  top: 0;
  right: 100px;
  align-items: end;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(10) {
  top: -20px;
  left: 112px;
  background: #26e5c6;
  color: #26e5c6;
}
.container-wheel-colaboradores .icons-colaboradores:nth-child(10) .box-info {
  top: -31px;
  right: 100px;
  align-items: end;
}

@media screen and (max-width: 1300px) {
  .container-wheel-colaboradores .icons-colaboradores .box-info {
    display: flex;
  }
  .container-wheel-colaboradores .icons-colaboradores .box-info .title-colaboradores {
    font-size: 18px;
    margin-right: -40px;
    margin-left: -40px;
  }
  .container-wheel-colaboradores .icons-colaboradores .box-info .detail-colaboradores {
    width: 83px;
    color: #4e5857;
    font-size: 12px;
    font-weight: bold;
  }
  .container-wheel-colaboradores .icons-colaboradores svg {
    width: 30px;
  }
  .container-wheel-colaboradores .ring-one {
    width: 300px;
    height: 300px;
    border: 3px solid rgba(123, 107, 228, 0.4);
  }
  .container-wheel-colaboradores .ring-two {
    border: 3px solid rgba(63, 196, 255, 0.4);
    border-radius: 50rem;
    width: 110%;
    height: 110%;
    margin-left: -12px;
    margin-top: -12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container-wheel-colaboradores .icons-colaboradores {
    width: 50px;
    height: 50px;
  }
  .container-wheel-colaboradores .icons-colaboradores img {
    width: 30px;
    height: 30px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(1) {
    top: -23px;
    left: 166px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(2) {
    top: 32px;
    left: 241px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(3) {
    top: 120px;
    left: 270px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(4) {
    top: 208px;
    left: 241px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(5) {
    top: 263px;
    left: 166px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(6) {
    top: 263px;
    left: 74px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(7) {
    top: 208px;
    left: -1px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(8) {
    top: 120px;
    left: -30px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(9) {
    top: 32px;
    left: -1px;
  }
  .container-wheel-colaboradores .icons-colaboradores:nth-child(10) {
    top: -23px;
    left: 74px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Views/Employee/Components/Wheel/wheel.sass"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AACD;AACC;EACC,0CAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;AACF;AACC;EACC,yCAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACC,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACH;AAAG;EACC,cAAA;EACA,YAAA;AAEJ;AADE;EACC,WAAA;EACA,kBAAA;EACA,gCAAA;AAGH;AACI;EACC,qBAAA;AACL;AAAI;EACC,YAAA;AAEL;AAAC;EACC,kBAAA;EACA,6MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAEF;AAAE;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAEH;AAAE;EACC,qBAAA;AAEH;AAAE;EACC,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAEH;AAAG;EACC,eAAA;AAEJ;AAAG;EACC,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAEJ;AAAE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAEH;AADG;EACC,UAAA;EACA,WAAA;AAGJ;AADE;EACC,SAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAGH;AAFG;EACC,MAAA;EACA,WAAA;AAIJ;AAFE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAIH;AAHG;EACC,MAAA;EACA,WAAA;AAKJ;AAHE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAKH;AAJG;EACC,MAAA;EACA,WAAA;AAMJ;AAJE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAMH;AALG;EACC,SAAA;EACA,WAAA;AAOJ;AALE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAOH;AANG;EACC,SAAA;EACA,YAAA;EACA,gBAAA;AAQJ;AANE;EACC,UAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAQH;AAPG;EACC,MAAA;EACA,YAAA;EACA,gBAAA;AASJ;AAPE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AASH;AARG;EACC,MAAA;EACA,YAAA;EACA,gBAAA;AAUJ;AARE;EACC,SAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAUH;AATG;EACC,MAAA;EACA,YAAA;EACA,gBAAA;AAWJ;AATE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAWH;AAVG;EACC,UAAA;EACA,YAAA;EACA,gBAAA;AAYJ;;AAVA;EAIG;IACC,aAAA;EAUF;EARE;IACC,eAAA;IACA,mBAAA;IACA,kBAAA;EAUH;EARE;IACC,WAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;EAUH;EARC;IACC,WAAA;EAUF;EARA;IACC,YAAA;IACA,aAAA;IACA,0CAAA;EAUD;EARA;IACC,yCAAA;IACA,oBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAUD;EARA;IACC,WAAA;IACA,YAAA;EAUD;EARC;IACC,WAAA;IACA,YAAA;EAUF;EARC;IACC,UAAA;IACA,WAAA;EAUF;EARC;IACC,SAAA;IACA,WAAA;EAUF;EARC;IACC,UAAA;IACA,WAAA;EAUF;EARC;IACC,UAAA;IACA,WAAA;EAUF;EARC;IACC,UAAA;IACA,WAAA;EAUF;EARC;IACC,UAAA;IACA,UAAA;EAUF;EARC;IACC,UAAA;IACA,UAAA;EAUF;EARC;IACC,UAAA;IACA,WAAA;EAUF;EARC;IACC,SAAA;IACA,UAAA;EAUF;EARC;IACC,UAAA;IACA,UAAA;EAUF;AACF","sourcesContent":[".container-wheel-colaboradores\r\n\tmargin: 80px auto\r\n\tdisplay: flex\r\n\tjustify-content: center\r\n\twidth: 100%\r\n\tposition: relative\r\n\r\n\t& .ring-one\r\n\t\tborder: 4px solid #7b6be466\r\n\t\tposition: relative\r\n\t\tborder-radius: 50rem\r\n\t\twidth: 410px\r\n\t\theight: 410px\r\n\r\n\t& .ring-two\r\n\t\tborder: 4px solid #3fc4ff66\r\n\t\tborder-radius: 50rem\r\n\t\twidth: 100%\r\n\t\theight: 100%\r\n\t\tdisplay: flex\r\n\t\tjustify-content: center\r\n\t\talign-items: center\r\n\r\n\t\t& .wheelEmployeeImgHover-editProfile\r\n\t\t\ttransition: all .8s ease-in-out\r\n\t\t\topacity: 0\r\n\t\t\tposition: absolute\r\n\t\t\tcolor: white\r\n\t\t\tfont-size: 20px\r\n\t\t\tfont-weight: 600\r\n\t\t\tmargin-top: 75px\r\n\t\t\tmargin-left: -160px\r\n\t\t\t& svg\r\n\t\t\t\tdisplay: block\r\n\t\t\t\tmargin: auto\r\n\t\t& img\r\n\t\t\twidth: 100%\r\n\t\t\tborder-radius: 50%\r\n\t\t\ttransition: all .8s ease-in-out\r\n\r\n\t\t& .wheelEmployeeLink-editProfile\r\n\t\t\t&:hover\r\n\t\t\t\t& img\r\n\t\t\t\t\ttransform: scale(1.2)\r\n\t\t\t\t& .wheelEmployeeImgHover-editProfile\r\n\t\t\t\t\topacity: .8\r\n\r\n\t& .icons-colaboradores\r\n\t\tborder-radius: 50%\r\n\t\tbox-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802)\r\n\t\twidth: 65px\r\n\t\theight: 65px\r\n\t\tposition: absolute\r\n\t\tdisplay: flex\r\n\t\tjustify-content: center\r\n\t\talign-items: center\r\n\t\ttransition: transform .3s\r\n\t\tcursor: pointer\r\n\t\tuser-select: none\r\n\r\n\t\t& svg\r\n\t\t\twidth: 45px\r\n\t\t\theight: 45px\r\n\t\t\tfill: white\r\n\t\t\tstroke-width: 25px\r\n\r\n\t\t&:hover\r\n\t\t\ttransform: scale(1.1)\r\n\r\n\t\t& .box-info\r\n\t\t\twidth: 220px\r\n\t\t\theight: 82px\r\n\t\t\tposition: absolute\r\n\t\t\tdisplay: flex\r\n\t\t\tflex-direction: column\r\n\r\n\t\t\t& .title-colaboradores\r\n\t\t\t\tfont-size: 20px\r\n\r\n\t\t\t& .detail-colaboradores\r\n\t\t\t\twidth: 83px\r\n\t\t\t\tcolor: #4e5857\r\n\t\t\t\tfont-size: 12px\r\n\t\t\t\tfont-weight: bold\r\n\r\n\t\t&:nth-child(1)\r\n\t\t\ttop: calc( 10px - 30px)\r\n\t\t\tleft: calc( 268px - 30px)\r\n\t\t\tbackground: #7b6be4\r\n\t\t\tcolor: #7b6be4\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: -31px\r\n\t\t\t\tleft: 100px\r\n\r\n\t\t&:nth-child(2)\r\n\t\t\ttop: calc( 85px - 30px)\r\n\t\t\tleft: calc( 371px - 30px)\r\n\t\t\tbackground: #6a84ec\r\n\t\t\tcolor: #6a84ec\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 0\r\n\t\t\t\tleft: 100px\r\n\r\n\t\t&:nth-child(3)\r\n\t\t\ttop: calc( 205px - 30px)\r\n\t\t\tleft: calc( 410px - 30px)\r\n\t\t\tbackground: #599df3\r\n\t\t\tcolor: #599df3\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 0\r\n\t\t\t\tleft: 100px\r\n\r\n\t\t&:nth-child(4)\r\n\t\t\ttop: calc( 325px - 30px)\r\n\t\t\tleft: calc( 371px - 30px)\r\n\t\t\tbackground: #4ab4fa\r\n\t\t\tcolor: #4ab4fa\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 0\r\n\t\t\t\tleft: 100px\r\n\r\n\t\t&:nth-child(5)\r\n\t\t\ttop: calc( 400px - 30px)\r\n\t\t\tleft: calc( 268px - 30px)\r\n\t\t\tbackground: #3fc4ff\r\n\t\t\tcolor: #3fc4ff\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 31px\r\n\t\t\t\tleft: 100px\r\n\r\n\t\t&:nth-child(6)\r\n\t\t\ttop: calc( 400px - 30px)\r\n\t\t\tleft: calc( 142px - 30px)\r\n\t\t\tbackground: #3bcaf5\r\n\t\t\tcolor: #3bcaf5\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 31px\r\n\t\t\t\tright: 100px\r\n\t\t\t\talign-items: end\r\n\r\n\t\t&:nth-child(7)\r\n\t\t\ttop: calc( 325px - 30px)\r\n\t\t\tleft: calc( 39px - 30px)\r\n\t\t\tbackground: #36d1ea\r\n\t\t\tcolor: #36d1ea\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 0\r\n\t\t\t\tright: 100px\r\n\t\t\t\talign-items: end\r\n\r\n\t\t&:nth-child(8)\r\n\t\t\ttop: calc( 205px - 30px)\r\n\t\t\tleft: calc( 0px - 30px)\r\n\t\t\tbackground: #31d7e0\r\n\t\t\tcolor: #31d7e0\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 0\r\n\t\t\t\tright: 100px\r\n\t\t\t\talign-items: end\r\n\r\n\t\t&:nth-child(9)\r\n\t\t\ttop: calc( 85px - 30px)\r\n\t\t\tleft: calc( 39px - 30px)\r\n\t\t\tbackground: #2cded3\r\n\t\t\tcolor: #2cded3\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: 0\r\n\t\t\t\tright: 100px\r\n\t\t\t\talign-items: end\r\n\r\n\t\t&:nth-child(10)\r\n\t\t\ttop: calc( 10px - 30px)\r\n\t\t\tleft: calc( 142px - 30px)\r\n\t\t\tbackground: #26e5c6\r\n\t\t\tcolor: #26e5c6\r\n\t\t\t& .box-info\r\n\t\t\t\ttop: -31px\r\n\t\t\t\tright: 100px\r\n\t\t\t\talign-items: end\r\n\r\n@media screen and ( max-width: 1300px )\r\n\t.container-wheel-colaboradores\r\n\r\n\t\t& .icons-colaboradores\r\n\t\t\t& .box-info\r\n\t\t\t\tdisplay: flex\r\n\r\n\t\t\t\t& .title-colaboradores\r\n\t\t\t\t\tfont-size: 18px\r\n\t\t\t\t\tmargin-right: -40px\r\n\t\t\t\t\tmargin-left: -40px\r\n\r\n\t\t\t\t& .detail-colaboradores\r\n\t\t\t\t\twidth: 83px\r\n\t\t\t\t\tcolor: #4e5857\r\n\t\t\t\t\tfont-size: 12px\r\n\t\t\t\t\tfont-weight: bold\r\n\r\n\t\t\t& svg\r\n\t\t\t\twidth: 30px\r\n\r\n\t\t& .ring-one\r\n\t\t\twidth: 300px\r\n\t\t\theight: 300px\r\n\t\t\tborder: 3px solid #7b6be466\r\n\r\n\t\t& .ring-two\r\n\t\t\tborder: 3px solid #3fc4ff66\r\n\t\t\tborder-radius: 50rem\r\n\t\t\twidth: 110%\r\n\t\t\theight: 110%\r\n\t\t\tmargin-left: -12px\r\n\t\t\tmargin-top: -12px\r\n\t\t\tdisplay: flex\r\n\t\t\tjustify-content: center\r\n\t\t\talign-items: center\r\n\r\n\t\t& .icons-colaboradores\r\n\t\t\twidth: 50px\r\n\t\t\theight: 50px\r\n\r\n\t\t\t& img\r\n\t\t\t\twidth: 30px\r\n\t\t\t\theight: 30px\r\n\r\n\t\t\t&:nth-child(1)\r\n\t\t\t\ttop: calc( 7px - 30px)\r\n\t\t\t\tleft: calc( 196px - 30px)\r\n\r\n\t\t\t&:nth-child(2)\r\n\t\t\t\ttop: calc( 62px - 30px)\r\n\t\t\t\tleft: calc( 271px - 30px)\r\n\r\n\t\t\t&:nth-child(3)\r\n\t\t\t\ttop: calc( 150px - 30px)\r\n\t\t\t\tleft: calc( 300px - 30px)\r\n\r\n\t\t\t&:nth-child(4)\r\n\t\t\t\ttop: calc( 238px - 30px)\r\n\t\t\t\tleft: calc( 271px - 30px)\r\n\r\n\t\t\t&:nth-child(5)\r\n\t\t\t\ttop: calc( 293px - 30px)\r\n\t\t\t\tleft: calc( 196px - 30px)\r\n\r\n\t\t\t&:nth-child(6)\r\n\t\t\t\ttop: calc( 293px - 30px)\r\n\t\t\t\tleft: calc( 104px - 30px)\r\n\r\n\t\t\t&:nth-child(7)\r\n\t\t\t\ttop: calc( 238px - 30px)\r\n\t\t\t\tleft: calc( 29px - 30px)\r\n\r\n\t\t\t&:nth-child(8)\r\n\t\t\t\ttop: calc( 150px - 30px)\r\n\t\t\t\tleft: calc( 0px - 30px)\r\n\r\n\t\t\t&:nth-child(9)\r\n\t\t\t\ttop: calc( 62px - 30px)\r\n\t\t\t\tleft: calc( 29px - 30px)\r\n\r\n\t\t\t&:nth-child(10)\r\n\t\t\t\ttop: calc( 7px - 30px)\r\n\t\t\t\tleft: calc( 104px - 30px)\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
